<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Grupos de Grade">
      <div class="grade-listagem">
        <Loading :isActive="loading" />

        <ModalGrupoGrade
          :item="currentItem"
          :colunasDisponiveis="colunasDisponiveis"
          :close="closeEdit"
        />

        <div class="grade-listagem__header">
          <CButton color="primary" @click="openCreate">
            <CIcon name="cil-plus" size="sm" class="mr-1" />
            Novo Grupo de Grade
          </CButton>
        </div>

        <div class="grade-listagem__filtros">
          <CRow>
            <CCol md="5">
              <div class="filtro-search-wrapper">
                <CIcon name="cil-magnifying-glass" size="sm" class="filtro-search-icon" />
                <input
                  class="form-control filtro-search-input"
                  type="text"
                  v-model="filtros.termo"
                  placeholder="Buscar por nome..."
                  @keyup.enter="loadGrupos()"
                />
              </div>
            </CCol>
            <CCol md="3">
              <select class="form-control" v-model="filtros.ativo">
                <option value="">Ativo: Todos</option>
                <option value="1">Ativo: Sim</option>
                <option value="0">Ativo: Não</option>
              </select>
            </CCol>
            <CCol md="2">
              <CButton color="primary" block @click="loadGrupos()">
                <CIcon name="cil-magnifying-glass" size="sm" class="mr-1" />
                Buscar
              </CButton>
            </CCol>
          </CRow>
        </div>

        <div class="grade-listagem__table-wrapper">
          <table class="grade-listagem__table">
            <thead>
              <tr>
                <th class="col-id">ID</th>
                <th class="col-nome">Nome</th>
                <th class="col-regras">Regras</th>
                <th class="col-campos">Campos</th>
                <th class="col-data">Criação</th>
                <th class="col-ativo">Ativo</th>
                <th class="col-acoes"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="grupos.length === 0">
                <td colspan="7" class="grade-listagem__empty">
                  <CIcon name="cil-ban" size="xl" class="grade-listagem__empty-icon" />
                  <p>Nenhum grupo de grade encontrado</p>
                </td>
              </tr>
              <tr
                v-for="grupo in grupos"
                :key="grupo.id"
                class="grade-listagem__row"
              >
                <td class="col-id">{{ grupo.id }}</td>
                <td class="col-nome">
                  <span class="grade-listagem__nome">{{ grupo.nome }}</span>
                  <div v-if="grupo.descricao" class="grade-listagem__descricao">
                    {{ grupo.descricao }}
                  </div>
                </td>
                <td class="col-regras">
                  <span class="contador-badge">{{ totalRegras(grupo) }}</span>
                </td>
                <td class="col-campos">
                  <span class="contador-badge contador-badge--info">{{ totalCampos(grupo) }}</span>
                </td>
                <td class="col-data">{{ grupo.datahora_criacao }}</td>
                <td class="col-ativo">
                  <span
                    class="sistema-badge"
                    :class="grupo.ativo ? 'sistema-badge--ativo' : 'sistema-badge--inativo'"
                  >
                    {{ grupo.ativo ? 'Sim' : 'Não' }}
                  </span>
                </td>
                <td class="col-acoes">
                  <CButton size="sm" color="primary" @click="editGrupo(grupo)" title="Alterar">
                    <fa-icon icon="pencil-alt" />
                  </CButton>
                  <CButton size="sm" color="danger" @click="deleteConfirm(grupo.id)" title="Excluir">
                    <fa-icon icon="trash-alt" />
                  </CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="grade-listagem__pagination">
          <pagination
            :data="table.paginator"
            :limit="5"
            @pagination-change-page="loadGrupos"
          />
        </div>
      </div>
    </CTab>
  </CTabs>
</template>

<script>
import { get, del } from "@/helpers/apiRequest";
import clone from "just-clone";
import Loading from "@/components/Loading.vue";
import ModalGrupoGrade from "./ModalGrupoGrade/ModalGrupoGrade.vue";

function defaultGrupo() {
  return {
    id: null,
    nome: "",
    descricao: "",
    ativo: 1,
    regras: [],
    campos: [],
  };
}

export default {
  name: "GruposGrade",
  components: { Loading, ModalGrupoGrade },
  data() {
    return {
      loading: false,
      currentItem: defaultGrupo(),
      grupos: [],
      colunasDisponiveis: [],
      filtros: { termo: "", ativo: "" },
      table: { paginator: {} },
    };
  },
  methods: {
    loadGrupos(page = 1) {
      this.loading = true;
      const { termo, ativo } = this.filtros;
      get(`/admin/grupo-grade?page=${page}&take=15&q=${termo}&ativo=${ativo}&column=id&order=ASC`)
        .then((json) => {
          this.grupos = json.itens || [];
          this.table.paginator = json.paginator || {};
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    loadColunasDisponiveis() {
      get("/admin/grupo-grade/colunas-disponiveis")
        .then((json) => {
          this.colunasDisponiveis = json.data || json || [];
        })
        .catch(() => {});
    },
    openCreate() {
      this.currentItem = defaultGrupo();
      this.$modal.show("ModalGrupoGrade");
    },
    editGrupo(grupo) {
      const cloned = clone(grupo);
      cloned.regras = (cloned.regras?.data || cloned.regras || []).map((regra) => ({
        colunaProduto: regra.coluna_produto || regra.colunaProduto,
        valor: regra.valor,
      }));
      cloned.campos = (cloned.campos?.data || cloned.campos || []).map((campo) => ({
        colunaProduto: campo.coluna_produto || campo.colunaProduto,
        labelCustomizado: campo.label_customizado || campo.labelCustomizado || "",
        ordem: campo.ordem ?? 0,
        eixo: campo.eixo || null,
      }));
      cloned.ativo = cloned.ativo ? 1 : 0;
      this.currentItem = cloned;
      this.$modal.show("ModalGrupoGrade");
    },
    closeEdit() {
      this.$modal.hide("ModalGrupoGrade");
      this.loadGrupos();
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Confirmar exclusão do grupo de grade?",
        text: "Produtos que pertenciam apenas a este grupo deixarão de ter grade. Essa ação não poderá ser desfeita.",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        this.loading = true;
        del(`/admin/grupo-grade/${id}`)
          .then(() => this.loadGrupos())
          .catch((err) => {
            this.$swal({ title: "Falha ao remover", text: err.message, icon: "error" });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    totalRegras(grupo) {
      return (grupo.regras?.data || grupo.regras || []).length;
    },
    totalCampos(grupo) {
      return (grupo.campos?.data || grupo.campos || []).length;
    },
  },
  beforeMount() {
    this.loadGrupos();
    this.loadColunasDisponiveis();
  },
};
</script>

<style scoped>
/* ===== HEADER ===== */
.grade-listagem__header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
}

/* ===== FILTROS ===== */
.grade-listagem__filtros {
  margin-bottom: 20px;
  padding: 16px;
  background: #f9fafb;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
}

.grade-listagem__filtros .form-control {
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #dddce9;
}

.grade-listagem__filtros .form-control:focus {
  border-color: #3a3e81;
  box-shadow: 0 0 0 2px rgba(58, 62, 129, 0.1);
}

.filtro-search-wrapper {
  position: relative;
}

.filtro-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #98a2b3;
  z-index: 1;
}

.filtro-search-input {
  padding-left: 36px !important;
}

/* ===== TABLE ===== */
.grade-listagem__table-wrapper {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  overflow: clip;
  background: #fff;
  margin-bottom: 20px;
}

.grade-listagem__table {
  width: 100%;
  border-collapse: collapse;
}

.grade-listagem__table thead tr {
  background: #f9fafb;
  border-bottom: 1px solid #e4e7eb;
}

.grade-listagem__table th {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 12px 12px;
  white-space: nowrap;
}

.grade-listagem__table td {
  padding: 12px 12px;
  border-bottom: 1px solid #f2f4f7;
  font-size: 13px;
  color: #344054;
  vertical-align: middle;
}

.grade-listagem__row:last-child td {
  border-bottom: none;
}

.grade-listagem__row:hover {
  background: #f9fafb;
}

.col-id { width: 60px; text-align: center; }
.col-nome { }
.col-regras { width: 80px; text-align: center; }
.col-campos { width: 80px; text-align: center; }
.col-data { width: 130px; text-align: center; }
.col-ativo { width: 70px; text-align: center; }
.col-acoes { width: 110px; text-align: center; white-space: nowrap; }

.grade-listagem__nome {
  font-weight: 500;
  color: #1d2939;
}

.grade-listagem__descricao {
  font-size: 12px;
  color: #98a2b3;
  margin-top: 2px;
}

/* ===== BADGES ===== */
.sistema-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.sistema-badge--ativo {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}

.sistema-badge--inativo {
  background: #f5f5f5;
  color: #999;
  border: 1px solid #e0e0e0;
}

.contador-badge {
  display: inline-block;
  min-width: 28px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  background: #f2f2f8;
  color: #3a3e81;
  border-radius: 12px;
  border: 1px solid #dddce9;
}

.contador-badge--info {
  background: #edf8f9;
  color: #1a7a83;
  border-color: #c5e6e9;
}

/* ===== EMPTY STATE ===== */
.grade-listagem__empty {
  text-align: center;
  padding: 48px 20px !important;
  color: #98a2b3;
}

.grade-listagem__empty-icon {
  color: #d0d5dd;
  margin-bottom: 8px;
}

.grade-listagem__empty p {
  font-size: 13px;
  margin: 0;
}

/* ===== PAGINATION ===== */
.grade-listagem__pagination {
  display: flex;
  justify-content: center;
}

/* ===== ACTIONS ===== */
.col-acoes .btn {
  margin: 0 2px;
}
</style>
